import { AuthFetchWithResponse } from 'src/Types/api'
import { transposeArrayType } from '../../../utils'
import { ApiResult, throwApiError } from 'src/Libs/api'
import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchError } from '@e3dc-react/shell/Types'
import { BadgeDto, BadgePOSTorPUTDto } from '../types'

export const getBadges = async (installationId: number, authFetch: AuthFetchWithResponse): Promise<ApiResult<BadgeDto[] | null>> => {
  try {
    const response = await authFetch<ArrayType<BadgeDto>>({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/badges`,
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<BadgeDto[]>(transposeArrayType(response.data))
  } catch (error) {
    return throwApiError(error, 'Failed to get badges:')
  }
}

export const createBadge = async (
  installationId: number,
  badge: BadgePOSTorPUTDto,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<number | null>> => {
  try {
    const response = await authFetch<number>({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/badges`,
      method: 'POST',
      payload: badge,
    })

    if (response.status !== StatusCodes.OK && response.status !== StatusCodes.CREATED) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<number>(response.data)
  } catch (error) {
    return throwApiError(error, 'Failed to create badge:')
  }
}

export const updateBadge = async (
  installationId: number,
  badgeId: string,
  badge: BadgePOSTorPUTDto,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<null>> => {
  try {
    const response = await authFetch({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/badges/${badgeId}`,
      method: 'PUT',
      payload: badge,
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<null>(null)
  } catch (error) {
    return throwApiError(error, 'Failed to update badge:')
  }
}

export const deleteBadge = async (installationId: number, badgeId: string, authFetch: AuthFetchWithResponse): Promise<ApiResult<null>> => {
  try {
    const response = await authFetch({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/badges/${badgeId}`,
      method: 'DELETE',
    })

    if (response.status !== StatusCodes.OK && response.status !== StatusCodes.NO_CONTENT) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<null>(null)
  } catch (error) {
    return throwApiError(error, 'Failed to delete badge:')
  }
}
